import React, { useEffect, useState } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import Cta from "../components/Cta";
import { client } from "../config/prismic";

const ReviewProcess = () => {
  const [guidelines, setGuidelines] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      const response = await client.getByType("review_process");
      setGuidelines(response.results); // Store the guidelines data
    };
    fetchData();
  }, []);

  if (!guidelines) {
    return (
      <div className="loader-container">
        <div className="loader"></div>
      </div>
    );
  }

  const renderTextWithSpans = (text, spans) => {
    let lastIndex = 0;
    const elements = [];

    spans.forEach((span) => {
      if (span.start > lastIndex) {
        elements.push(text.slice(lastIndex, span.start));
      }

      if (span.type === "strong") {
        elements.push(
          <strong key={`${span.start}-${span.end}`} className="font-semibold">
            {text.slice(span.start, span.end)}
          </strong>
        );
      } else if (span.type === "hyperlink") {
        elements.push(
          <a
            key={`${span.start}-${span.end}`}
            href={span.data.url}
            target="_blank"
            rel="noopener noreferrer"
            className="text-blue-500 underline"
          >
            {text.slice(span.start, span.end)}
          </a>
        );
      }

      lastIndex = span.end;
    });

    if (lastIndex < text.length) {
      elements.push(text.slice(lastIndex));
    }

    const finalElements = [];

    elements.forEach((element, idx) => {
      if (typeof element === "string") {
        const parts = element.split("\n");
        parts.forEach((part, partIdx) => {
          finalElements.push(
            <span key={`text-${idx}-${partIdx}`}>{part}</span>
          );
          if (partIdx !== parts.length - 1) {
            finalElements.push(<br key={`br-${idx}-${partIdx}`} />);
          }
        });
      } else {
        finalElements.push(element);
      }
    });

    return finalElements;
  };

  return (
    <div>
      <Header page={true} />
      <Cta />
      <div className="sec-title3 text-center mt-5 pt-5">
        <span>Review Process</span>
        <h2>Review Process</h2>
      </div>

      <div className="container my-5">
        {guidelines.map((guideline, index) => (
          <div key={index} className="card shadow-lg mb-4">
            <div className="card-body leading-relaxed">
              {guideline.data.review.map((item, itemIndex) => (
                <div key={itemIndex} className="">
                  {item.type === "heading3" ? (
                    <h3 className="font-semibold mb-0">
                      {renderTextWithSpans(item.text, item.spans)}
                    </h3>
                  ) : (
                    <p className="text-justify mb-2">
                      {renderTextWithSpans(item.text, item.spans)}
                    </p>
                  )}
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>

      <Footer />
    </div>
  );
};

export default ReviewProcess;
